import gql from 'graphql-tag';
import { kmsClient } from 'api/index';
import { useMutation } from '@apollo/react-hooks';
import { DeleteArticleAssets, DeleteArticleAssetsVariables } from './__generated__/DeleteArticleAssets';

const DELETE_ARTICLE_ASSETS = gql`
  mutation DeleteArticleAssets($assetIds: [ID!]!) {
    deleteArticleAssets(assetIds: $assetIds) {
      success
      errors
    }
  }
`;

export const useDeleteArticleAssetsMutation = () => {
  return useMutation<DeleteArticleAssets, DeleteArticleAssetsVariables>(DELETE_ARTICLE_ASSETS, {
    client: kmsClient
  });
};
